import React, { useRef } from 'react';
import Button from '@material-ui/core/Button';

export default function CopyToClipboardElement (props) {
    const textareaRef = useRef(null);
    const Element=props.element || Button;
    const {element, label, text, ...elementProps} = props;
console.log("CopyToClipboardButton: %o",elementProps)
    const copyToClipboard = () => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(props.text)
                .then(() => {
                    console.log('Text (%o) copied to clipboard new',props.text);
                })
                .catch((error) => {
                    console.error('Failed to copy text: ', error);
                });
        } else {
            textareaRef.current.select();
            document.execCommand('copy');
            console.log('Text (%o) copied to clipboard old',props.text);
        }
    };

    return (
        <>
      <textarea ref={textareaRef}
                value={props.text}
                style={{position: 'absolute', left: '-9999px'}}
                readOnly
      />
            <Element
                {...elementProps}
                onClick={copyToClipboard}
            >{props.label}</Element>

        </>
    );
};

